export const GET_REQUEST_DATA_KIDS = "GET_REQUEST_DATA_KIDS";
export const GET_FAILURE_DATA_KIDS = "GET_FAILURE_DATA_KIDS";
export const GET_SUCCESS_DATA_KIDS = "GET_SUCCESS_DATA_KIDS";

export const GET_REQUEST_DATA_MEN = "GET_REQUEST_DATA_MEN";
export const GET_FAILURE_DATA_MEN = "GET_FAILURE_DATA_MEN";
export const GET_SUCCESS_DATA_MEN = "GET_SUCCESS_DATA_MEN";

export const GET_REQUEST_DATA_WOMEN = "GET_REQUEST_DATA_WOMEN";
export const GET_FAILURE_DATA_WOMEN = "GET_FAILURE_DATA_WOMEN";
export const GET_SUCCESS_DATA_WOMEN = "GET_SUCCESS_DATA_WOMEN";

export const GET_REQUEST_DATA_BEAUTY = "GET_REQUEST_DATA_BEAUTY";
export const GET_FAILURE_DATA_BEAUTY = "GET_FAILURE_DATA_BEAUTY";
export const GET_SUCCESS_DATA_BEAUTY = "GET_SUCCESS_DATA_BEAUTY";

export const GET_REQUEST_DATA_SALE = "GET_REQUEST_DATA_SALE";
export const GET_FAILURE_DATA_SALE = "GET_FAILURE_DATA_SALE";
export const GET_SUCCESS_DATA_SALE = "GET_SUCCESS_DATA_SALE";


